'use strict';

angular.module('dstreamApp.controllers').controller('customerDialogController', [
    '$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
}])